import React from 'react'

import { Box } from '@vividseats/vivid-ui-kit'

import { ValueContainer } from './components/valueContainer'
import { boxValues } from './constants'
import styles from './styles.module.scss'

const RewardValues: React.FC = () => {
    return (
        <Box
            paddingTop={10}
            paddingBottom={10}
            justify="between"
            desktopFlexDirection="row"
            tabletFlexDirection="column"
            mobileFlexDirection="column"
            align="center"
            className={styles.valueBoxes}
        >
            {boxValues.map(({ value, text, suffix }, index) => {
                let textClassName
                if (index === 2) textClassName = styles.thirdText
                return (
                    <ValueContainer
                        key={value}
                        value={value}
                        text={text}
                        suffix={suffix}
                        textClassName={textClassName}
                    />
                )
            })}
        </Box>
    )
}

export default RewardValues
